import Axios from "axios";

export class Receipt {
  // Set receipt url
  constructor(apiUrl, headers) {
    this.receiptUrl = `${apiUrl}/subscriptions/receipts`;
    this.headers = headers;
  }

  async getDecryptedTaxId(id) {
    const url = `${this.receiptUrl}/${id}/decrypt/tax-id`;

    const response = await Axios.get(url, {
      headers: this.headers
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient/receipt.js